'use client';

import { articleListingSection } from '@stereoagency/sanity-schema';
import { useContext } from 'react';
import useSWR from 'swr';
import { articlesQuery } from './articlesQuery';
import ArticleListingSection from './ArticleListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

type Props = Omit<
  typeof articleListingSection.schema.articleListingSection,
  '_type'
> & {};

export default function DraftModeArticleListingSection({
  enableTaxonomyFilter
}: Props) {
  const { client } = useContext(SanityDraftClientContext);

  const { data } = useSWR('articles', () =>
    client?.fetch<(typeof articlesQuery)[1]>(articlesQuery[0])
  );

  return (
    <ArticleListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      articles={data ?? []}
    />
  );
}
